
export function auth() {
	const signup = (credentials) => {
		return fetch(`${process.env.REACT_APP_URL}/users/RegisterUser`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(credentials)
		}).then(async (response) => {
			const data = await response.json();
			if (response.status === 200) {
				return { status: true, response: data.message };
			} else {
				return { status: false, response: data.message };
			}
		});
	};

	const login = (credentials) => {
		return fetch(`${process.env.REACT_APP_URL}/Users/authenticate`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(credentials)
		}).then(async (response) => {
			const data = await response.json();
			if (response.status === 200) {
				if ('accessToken' in data) {
					localStorage.setItem('token', data.accessToken);
					localStorage.setItem('user', JSON.stringify({ id: data.user?.id, firstName: data.user?.firstName, lastName: data.user?.lastName, email: data.user?.email, roles: data.user?.roles }));
					return true;
				}
				return false;
			} else {
				return false;
			}
		});
	};

	const updateUser = (data) => {
		localStorage.setItem('user', JSON.stringify({ id: data?.id, firstName: data?.firstName, lastName: data?.lastName, email: data?.email, roles: data?.roles }));
	}

	const logout = () => {
		localStorage.removeItem('token');
		localStorage.removeItem('user');
	};

	const getToken = () => {
		return localStorage.getItem('token');
	};

	const getUser = () => {
		return JSON.parse(localStorage.getItem('user'));
	};

	const isAdmin = () => {
		const user = getUser();
		if (!user) {
			return false;
		}
		if (user.roles.indexOf("Admin") > -1) {
			return true;
		}
		return false;
	};

	return {
		signup,
		login,
		logout,
		getToken,
		getUser,
		isAdmin,
		updateUser
	};
}